import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { WebphoneQuery, CallingState } from '@etop/state/shop/webphone';
import { Observable } from 'rxjs';
import { PageBaseComponent } from '@etop/web';
import { takeWhile } from 'rxjs/operators';

@Component({
  selector: 'etelecom-cs-webphone',
  templateUrl: './webphone.component.html',
  styleUrls: ['./webphone.component.scss']
})
export class WebphoneComponent extends PageBaseComponent implements OnInit, OnDestroy {

  @ViewChild('localVideo') localVideoElement: ElementRef<HTMLVideoElement>;
  @ViewChild('remoteVideo') remoteVideoElement: ElementRef<HTMLVideoElement>;
  @ViewChild('remoteAudio') remoteAudioElement: ElementRef<HTMLAudioElement>;
  @ViewChild("localAudio", { static: true }) localAudio: ElementRef<HTMLAudioElement>;
  localAudioSrc$ = this.webphoneQuery.select("localAudioSrc");
  callState$ = this.webphoneQuery.select(state => state.callState);

  isVideoCall$: Observable<boolean>;

  localVideoSrc$: Observable<MediaStream>;
  remoteVideoSrc$: Observable<MediaStream>;

  CallingState = CallingState;

  constructor(
    private webphoneQuery: WebphoneQuery
  ) {
    super();
  }

  ngOnInit(): void {
    this.isVideoCall$ = this.webphoneQuery.select(state => state.isVideoCall);
    this.localVideoSrc$ = this.webphoneQuery.select(state => state.localVideoSrcObject);
    this.remoteVideoSrc$ = this.webphoneQuery.select(state => state.remoteVideoSrcObject);

    // Setup video streams
    this.localVideoSrc$.pipe(takeWhile(() => !this.destroy$)).subscribe(stream => {
      if (this.localVideoElement?.nativeElement && stream) {
        this.localVideoElement.nativeElement.srcObject = stream;
      }
    });

    this.remoteVideoSrc$.pipe(takeWhile(() => !this.destroy$)).subscribe(stream => {
      if (this.remoteVideoElement?.nativeElement && stream) {
        this.remoteVideoElement.nativeElement.srcObject = stream;
      }
    });
    this.localAudioSrc$.subscribe((audioSrc) => {
      if (audioSrc) {
        this.playRingBack(audioSrc).then();
      } else {
        this.stopRingBack().then();
      }
    });
  }

  onPlayAudioUrl(url: string) {
    return url ? this.playRingBack(url) : this.stopRingBack();
  }

  async playRingBack(audioSrc: string) {
    try {
      this.localAudio.nativeElement.src = audioSrc;
      this.localAudio.nativeElement.loop =
        audioSrc !=
        "https://etelecom.s3south.storage.com.vn/ringtones/endcall_sound.wav";
      await this.localAudio.nativeElement.play();
    } catch (e) {
      console.error("ERROR in playRingBack", e);
    }
  }

  async stopRingBack() {
    try {
      this.localAudio.nativeElement.src = "";
      await this.localAudio.nativeElement.pause();
    } catch (e) {
      console.error("ERROR in stopRingBack", e);
    }
  }

  
}

